import type { DeletionRequestsData } from '@core/account-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<DeletionRequestsData | null>()(EntityStoreKey.deletionRequests);

export {
  actions as DeletionRequestsActions,
  selectors as DeletionRequestsSelectors,
  reducer as DeletionRequestReducer,
  namespace as DeletionRequestNamespace,
};
